export const mainConfig = {
  googleAPIKey: 'AIzaSyDDJAqvJaa0yVGeaXjhruQpDzN1EsnKyMA',
  guruServiceFee: 0.1,
  activityServiceFee: 0.1,
  planS3: 'https://s3.amazonaws.com/tripguru/plan-',
  pdfGateway: 'https://kh3q2cp5q1.execute-api.us-east-1.amazonaws.com/live/tripplankinesis?planId='
}

const devConfig = {
  fileAPI: 'https://hasura.gettrip.guru/v1/graphql',
  simpleAPI: 'https://hasura.gettrip.guru/v1/graphql',
  subscriptionAPI: 'wss://hasura.gettrip.guru/v1/graphql',
  imgApiUrl: 'https://tripguru-files-graphcool.s3.eu-central-1.amazonaws.com',
  authClientId: 'b6EgiKD85FqrOU4COqpt49jq3zq1DJc5',
  authDomain: 'zibaba.auth0.com',
  authRedirect: '/',
  authUserInfo: 'https://zibaba.auth0.com/userinfo',
  clientId: 'b6EgiKD85FqrOU4COqpt49jq3zq1DJc5',
  domain: 'zibaba.auth0.com',
  passwordAPI: 'https://zibaba.auth0.com/api/v2/users/',
  tokenAPI: 'https://zibaba.auth0.com/oauth/token',
  authAPIClientId: 'weOHc9IHBgA5Bn6FJa4xBSiI5eJw8q0L',
  authAPIClientSecret: '2VoTLg8sz_53bEh7FJDb6cwlXex6VnvVZuDPC6DmQ6kyRjVtcfToWmekH46krpHp',
  authApiUrl: 'https://zibaba.auth0.com/api/v2/',
  dbConnectionsApi: 'https://zibaba.auth0.com/dbconnections/',
  hasuraAdminSecret: process.env.HASURAADMINSECRET
}

/*
authAPIClientId: '6EXWNdFkQYeFwwm2CSliB0RovGqsHaBm',
authAPIClientSecret: 'Em1IH5hSoXtDURgMo3KCBkpZewTC8rbZ0bqcWEE-4iv0fQkqU0lM-3qwIXGnnewY',
*/

const prodConfig = {
  fileAPI: 'https://hasura.gettrip.guru/v1/graphql',
  simpleAPI: 'https://hasura.gettrip.guru/v1/graphql',
  subscriptionAPI: 'wss://hasura.gettrip.guru/v1/graphql',
  imgApiUrl: 'https://tripguru-files-graphcool.s3.eu-central-1.amazonaws.com',
  authClientId: 'ICvUBME8ABY1rNK63D5py5R9TSD88WDg',
  authDomain: 'tripguru.eu.auth0.com',
  authRedirect: '/',
  authUserInfo: 'https://tripguru.eu.auth0.com/userinfo',
  domain: 'tripguru.eu.auth0.com',
  passwordAPI: 'https://tripguru.eu.auth0.com/api/v2/users/',
  tokenAPI: 'https://tripguru.eu.auth0.com/oauth/token',
  authAPIClientId: '6EXWNdFkQYeFwwm2CSliB0RovGqsHaBm',
  authAPIClientSecret: 'Em1IH5hSoXtDURgMo3KCBkpZewTC8rbZ0bqcWEE-4iv0fQkqU0lM-3qwIXGnnewY',
  authApiUrl: 'https://tripguru.eu.auth0.com/api/v2/',
  dbConnectionsApi: 'https://tripguru.eu.auth0.com/dbconnections/',
  hasuraAdminSecret: process.env.HASURAADMINSECRET
}

export const pixabayConfig = {
  key: '7618368-1e79649c332013146057e3ad7'
}
export const unsplashConfig = {
  name: 'trippere',
  appId: '1dea15c75378e83ab47999386b92b3040284f1ecc11f10b5c951d6fb0258e8ed',
  secret: 'ea7fcb151e71aaa28f3f8574783e8b55786f1b83c94ac2d47b3570a9e9d43c1d',
  token: '040cd5e0171d121674618203c52e72a714e353c49a9297bbf10a085c86ce7c32',
  callbackUrl: 'urn:ietf:wg:oauth:2.0:oob' // It just for localhost/dev
}

export const braintreePaymentConfig = {
  REACT_APP_LAMBDA_ROOT: 'https://6gmfpq9me7.execute-api.us-east-1.amazonaws.com/bt/',
  tokenizationKey: 'sandbox_k84gdb6r_h7rq9rw5mvkx8wsf'
}

let config
if (process.env.REACT_APP_CONFIG_TYPE === 'prod') {
  config = prodConfig
}
else {
  config =  prodConfig //devConfig
}
export default config



// WEBPACK FOOTER //
// src/config.js